import React, { Component } from "react";
import { withStyles, Button } from "@material-ui/core";

const styles = theme => ({
    root: {
        paddingLeft: "36px",
        paddingRight: "36px"
    }
})

class WideButton extends Component {

    render() {
        const { classes, children, ...props } = this.props
        return (
            <Button classes={classes} {...props}>
                {children}
            </Button>
        );
    }

}

export default withStyles( styles )( WideButton );